import { render, staticRenderFns } from "./tzddtgzb.vue?vue&type=template&id=176d05cc&scoped=true&"
import script from "./tzddtgzb.vue?vue&type=script&lang=js&"
export * from "./tzddtgzb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176d05cc",
  null
  
)

export default component.exports